import { Icon } from '@rbilabs/universal-components';

import { PressableItemCard } from 'components/quests/components/pressable-item-card';
import { getDesignToken, primitive } from 'styles/constants';
export const PressableItem = PressableItemCard.withConfig(p => ({
  borderRadius: 'lg',
  overflow: 'visible',
  minHeight: '72px',
  ...(!p.disabled && {
    background: primitive.$white,
    shadow: '1',
  }),
}));

export const CompletedStepIcon = Icon.withConfig({
  variant: 'checkFill',
  color: getDesignToken('background-contrast-loyalty-reversed'),
});

export const UncompletedStepIcon = Icon.withConfig({
  variant: 'forward',
});
